var zo = zo || {};


// Aload
//-----------------------------------------------------------------
zo.aload = function() {

    aload();
    
};


$(document).ready(function (){
    zo.aload();
});